import Navbar from "../Layout/Navbar";
import Hero from "../components/Homepage/Hero";
import Intro from "../components/Homepage/Intro";
import Services from "../components/Homepage/Services";
import About from "../components/Homepage/About";
import Testimonials from "../components/Homepage/Testimonials";
import ContactCTA from "../components/Homepage/ContactCTA";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Fbchat from "components/Fbchatplusgin/Fbchat";
import Fbpost from "components/Fbchatplusgin/Fbpost";
import FloatingChat from "components/Fbchatplusgin/FloatingChat";
import BlogSection from "components/Homepage/BlogSection";
import TikTokSection from "components/Tiktok/TikTokSection";

const HomePage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    }
  }, [hash]);

  return (
    <div className="bg-darkbg text-white">
      <section id="hero">
        <Hero />
      </section>

      <section id="intro">
        <Intro />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="testimonials">
        <Testimonials />
      </section>

      {/* <Fbchat /> */}
      <Fbpost />

      <TikTokSection />

      <BlogSection />

      <FloatingChat />

      <section id="contact">
        <ContactCTA />
      </section>
    </div>
  );
};

export default HomePage;
